import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography
} from '@mui/material';
import pallet from '../../../layouts/pallet';
import styled from 'styled-components';

export const FormHeader = styled(Typography).attrs({
  variant: 'h5',
  as: 'h2'
})({
  fontWeight: 'bold'
});

export const AccordionHeading = styled(Typography)({
  fontSize: '4rem',
  fontWeight: 'bold',
  flexShrink: 0
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  display: 'block',
  padding: '16px 24px 24px'
});

export const FixedHeaderBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 20px',
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 1000,
  backgroundColor: pallet.white,
  boxSizing: 'border-box',
  transition: 'box-shadow 0.3s ease-in-out',
  boxShadow: `0px 2px 4px -1px ${pallet.shadowLight}, 0px 4px 5px 0px ${pallet.shadowMedium}, 0px 1px 10px 0px ${pallet.shadowDefault}`
});

export const Subtitle1Large = styled(Typography).attrs({
  variant: 'subtitle1'
})({
  '&.MuiTypography-subtitle1': {
    fontWeight: 600,
    fontSize: '1rem !important',
  }
});

export const RoleAccordion = styled(Accordion)({
  border: `1px solid ${pallet.N40}`,
  boxShadow: 'none',
  borderRadius: '8px !important',
  '&:not(:last-child)': {
    marginBottom: '16px'
  },
  '&:before': {
    display: 'none'
  }
});

export const RoleAccordionSummary = styled(AccordionSummary)({
  padding: '0 16px',
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

export const RoleAccordionDetails = styled(AccordionDetails)({
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 24px 16px 24px',
  backgroundColor: pallet.N20,
  borderTop: `1px solid ${pallet.N40}`,
  position: 'relative',
  minHeight: '80px'
});

export const CustomFieldHeader = styled(Box)({
  display: 'flex',
  backgroundColor: pallet.N20,
  borderTop: `1px solid ${pallet.N50}`,
  borderBottom: `1px solid ${pallet.N50}`,
  padding: '8px 16px'
});

export const CustomFieldHeaderColumn = styled(Box)({
  flex: 1
});

export const CustomFieldRow = styled(Box)({
  display: 'flex',
  alignItems: 'start',
  borderBottom: `1px solid ${pallet.N40}`,
  padding: '8px 16px'
});

export const CustomFieldColumn = styled(Box)({
  flex: 1,
  paddingRight: '8px'
});

export const CustomFieldActionColumn = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
